module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/image-4-294a002e970d29d5496ad09668d045fa.jpg";